// One-click "Add" for upsell items in the cart drawer and cart page.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.mi-upsell__add');
  if (!btn) return;
  btn.setAttribute('aria-busy', 'true');
  const drawer = document.querySelector('cart-drawer');
  try {
    const res = await fetch(window.Shopify?.routes?.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Could not add item');
    if (drawer && data.sections) {
      drawer.renderContents({ ...data, id: data.items?.[0]?.key });
    } else {
      window.location.reload();
    }
  } catch (err) {
    btn.removeAttribute('aria-busy');
    alert(err.message);
  }
});
